import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IMei from "Types/IMei";
import { State } from "store/reducers";

export const GET_MEI = "[MEI GET] GET_MEI";
export const GET_MEI_SUCCESS =
	"[MEI GET] GET_MEI_SUCCESS";
export const GET_MEI_FAILED =
	"[MEI GET] GET_MEI_FAILED";

export const SET_VALUE = "[MEI GET] SET_VALUE";
export const CLEAR_VALUES = "[MEI GET] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getMei(id: string, callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_MEI });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Mei/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_MEI_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_MEI_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_MEI_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export const GET_SPLITS = "[MEI GET] GET_SPLITS";
export const GET_SPLITS_SUCCESS = "[MEI GET] GET_SPLITS_SUCCESS";
export const GET_SPLITS_FAILED = "[MEI GET] GET_SPLITS_FAILED";

export function getSplits(id: string, callback?: Callback<IMei>) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_SPLITS });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Mei/" + id + "/Splits", {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_SPLITS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SPLITS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_SPLITS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export const CREATE_SPLIT = "[MEI GET] CREATE_SPLIT";
export const CREATE_SPLIT_SUCCESS = "[MEI GET] CREATE_SPLIT_SUCCESS";
export const CREATE_SPLIT_FAILED = "[MEI GET] CREATE_SPLIT_FAILED";

export function createSplit(
	id: any,
	model: any,
	callback?: Callback<IMei>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: CREATE_SPLIT });

		try {
			const { login } = getState() as State;

			const response = await api.sendPost(
				"/Mei/" + id + "/Splits",
				model,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: CREATE_SPLIT_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_SPLIT_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			callback && callback(error);

			return dispatch({
				type: CREATE_SPLIT_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
